(() => {
  if (window.__raMobileCartInitialised) return;
  window.__raMobileCartInitialised = true;

  const isMobile = () => window.matchMedia('(max-width: 767px)').matches;
  let updateTimer = null;
  let lastCount = null;

  const cartUrl = () => `${window.Shopify?.routes?.root || '/'}cart.js`;

  const renderTitle = (count) => {
    const title = document.querySelector('#MinimogCartDrawer .m-cart-drawer__title');
    if (!title) return;

    let counter = title.querySelector('.ra-cart-count');
    if (!counter) {
      title.textContent = 'CARRELLO';
      counter = document.createElement('span');
      counter.className = 'ra-cart-count';
      title.appendChild(counter);
    }

    counter.textContent = `(${count} ${count === 1 ? 'Articolo' : 'Articoli'})`;
  };

  const quantityFallback = () => Array.from(
    document.querySelectorAll('#MinimogCartDrawer input[name="updates[]"]:not([disabled])')
  ).reduce((total, input) => total + (Number(input.value) || 0), 0);

  const updateCount = async () => {
    if (!isMobile()) return;

    const fallback = quantityFallback();
    if (fallback !== lastCount) {
      lastCount = fallback;
      renderTitle(fallback);
    }

    try {
      const response = await fetch(cartUrl(), { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      lastCount = Number(cart.item_count) || 0;
      renderTitle(lastCount);
    } catch (error) {}
  };

  const scheduleUpdate = () => {
    window.clearTimeout(updateTimer);
    updateTimer = window.setTimeout(updateCount, 120);
  };

  const start = () => {
    scheduleUpdate();

    const drawer = document.getElementById('MinimogCartDrawer');
    if (!drawer || drawer.dataset.raCountObserver === 'true') return;
    drawer.dataset.raCountObserver = 'true';

    const observer = new MutationObserver((mutations) => {
      const relevant = mutations.some((mutation) =>
        mutation.type === 'childList' ||
        (mutation.type === 'attributes' && mutation.attributeName === 'value')
      );
      if (relevant) scheduleUpdate();
    });

    observer.observe(drawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value']
    });

    drawer.addEventListener('change', scheduleUpdate);
    drawer.addEventListener('click', (event) => {
      if (event.target.closest('.m-quantity__button, m-cart-remove-button')) {
        window.setTimeout(scheduleUpdate, 250);
        window.setTimeout(scheduleUpdate, 700);
      }
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  window.addEventListener('load', start);
  window.addEventListener('resize', scheduleUpdate);
  document.addEventListener('shopify:section:load', start);
  document.addEventListener('cart:updated', scheduleUpdate);
  document.addEventListener('cart:refresh', scheduleUpdate);
})();

/* RA Boutique — load popup Bikini + Pareo Shine */
(() => {
  if (window.__raBikiniShineLoader) return;
  window.__raBikiniShineLoader = true;
  const current = document.currentScript && document.currentScript.src;
  if (!current) return;
  const script = document.createElement('script');
  script.src = current.replace(/ra-mobile-cart\.js(?:\?.*)?$/, 'ra-bikini-shine-popup.js?ra=1');
  script.defer = true;
  document.head.appendChild(script);
})();